module.exports = __webpack_public_path__ + "media/apps/instacart-logo-white-1fa4a4ae.svg";